// extracted by mini-css-extract-plugin
export default {"tab":"Filters_tab__TiT-b"};